import TransferHeader from './TransferHeader';
import TextEntity from './TextEntity';
import NormalButton from './NormalButton';

import UsFlag from '../../assets/flags/usa.svg';

export default function TransferConfirmForm({
  onCancel,
  onOffRamp,
  setProgress,
  amount,
  currency,
  dollarAmount,
  feePercent = 0.5,
  exchangeRate,
  data,
  isNewAccount,
  submitting,
  concept,
  countryName,
}) {
  const localAmount = parseFloat(amount) || 0;
  const usdTotal = parseFloat(dollarAmount) || 0;
  const isUSD = countryName === 'Estados Unidos';
  const feeUsd = usdTotal * (feePercent / (100 + feePercent));
  const usdBeforeFee = usdTotal - feeUsd;

  const fmt = (n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <>
      <TransferHeader
        headerTitle="Confirmación"
        description="Confirma los siguientes datos para concretar la transferencia"
        goBack={() => setProgress(1)}
      />

      <div className="space-y-4">
        <div className="w-full bg-gradient-to-r from-[#FFFFFF] to-[#E7EFFF] py-3 border border-[#E6EBF7] rounded-[10px]">
          <div className="h-[29px] flex items-center justify-center space-x-1">
            <p className="inline text-sm text-[#092F7B] font-semibold leading-[22px]">
              Recibe el destinatario
            </p>
          </div>
          <div className="h-9 flex items-center justify-center space-x-1">
            <p className="text-xl text-[#181D27] font-semibold text-center py-1">
              {`$${fmt(localAmount)} ${currency}`}
            </p>
          </div>
        </div>

        {data.map((item, idx) => (
          <TextEntity key={idx} title={item.title} content={item.content} />
        ))}
        {concept && (
          <TextEntity title="Concepto" content={concept} />
        )}

        {/* Fee breakdown */}
        <div className="pt-3 border-t-1 border-t-[#D5D7DA] space-y-2">
          {!isUSD && (
            <div className="flex items-center justify-between text-sm text-[#535862] font-[poppins]">
              <span>Monto a convertir</span>
              <span className="font-medium text-[#181D27]">${fmt(usdBeforeFee)} USD</span>
            </div>
          )}
          <div className="flex items-center justify-between text-sm text-[#535862] font-[poppins]">
            <span>Comisión FlowexPay ({feePercent}%)</span>
            <span className={`font-medium ${feePercent === 0 ? 'text-[#16A34A]' : 'text-[#181D27]'}`}>
              {feePercent === 0 ? 'Gratis' : `$${fmt(feeUsd)} USD`}
            </span>
          </div>
          <div className="flex items-center justify-between text-lg text-[#252B37] font-semibold pt-1">
            <span>Total a debitar</span>
            <span>${fmt(usdTotal)} USD</span>
          </div>
          {!isUSD && (
            <p className="text-[10px] text-[#717680] leading-[14px] pt-1">
              * El monto final puede variar ligeramente debido a tasas de conversión aplicadas por el banco intermediario o destino, ajenas a FlowexPay.
            </p>
          )}
        </div>
      </div>

      <div className="space-y-2">
        {isNewAccount && (
          <div className="flex space-x-2">
            <input type="checkbox" className="min-w-4 w-4 h-4 mt-1"></input>
            <p className="text-xs text-[#252B37] font-normal leading-[20px]">
              Confirmo que es una primera trasnferencia al beneficiario
            </p>
          </div>
        )}
        <div className="flex space-x-2">
          <input type="checkbox" className="min-w-4 w-4 h-4 mt-1"></input>
          <p className="text-xs text-[#252B37] font-normal leading-[20px]">
            Confirmo que acepto las normas de la UIAF y el Banco de la República para realizar
            operaciones financieras.
          </p>
        </div>
      </div>

      <span className="float-right">
        <div className="space-x-2.5">
          <NormalButton customClass="text-[#092F7B] bg-white" text="Cancelar" onClick={onCancel} />
          <NormalButton
            customClass="text-[#FDFDFD] bg-[#092F7B] disabled:opacity-70 disabled:cursor-not-allowed"
            text={submitting ? 'Em Processo...' : 'Confirmar'}
            onClick={onOffRamp}
            disabled={submitting}
          />
        </div>
      </span>
    </>
  );
}
